import { render, staticRenderFns } from "./WeaponStats.vue?vue&type=template&id=0f73dcec&scoped=true&"
import script from "./WeaponStats.vue?vue&type=script&lang=js&"
export * from "./WeaponStats.vue?vue&type=script&lang=js&"
import style0 from "./WeaponStats.vue?vue&type=style&index=0&id=0f73dcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f73dcec",
  null
  
)

export default component.exports